import { render, staticRenderFns } from "./JobCreate.vue?vue&type=template&id=4856d1a3&scoped=true"
import script from "./JobCreate.vue?vue&type=script&lang=js"
export * from "./JobCreate.vue?vue&type=script&lang=js"
import style0 from "./JobCreate.vue?vue&type=style&index=0&id=4856d1a3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4856d1a3",
  null
  
)

export default component.exports